import React, { useEffect, useState } from 'react';
import {
  Modal,
  Button,
  Table,
  Spinner,
  OverlayTrigger,
  Tooltip,
} from 'react-bootstrap';
import { FaRegCopy } from 'react-icons/fa';
import { toast } from 'react-toastify';
import { fetchStressByCod } from '../../../services/stress';
import api from '../../../services/api';

export default function ModalStress({ show, onHide, codPac, onCopy }) {
  const [laudos, setLaudos] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (show && codPac) {
      setLoading(true);
      api
        .get(`pacientes/${codPac}/atividades`)
        .then(res => {
          const filtered = res.data.filter(a =>
            [13, 14].includes(a.CODPROCEDI) // CODPROCEDI_STRESS
          );
          setLaudos(filtered);
        })
        .catch(() => toast.error('Erro ao buscar laudos de Stress anteriores.'))
        .finally(() => setLoading(false));
    }
  }, [show, codPac]);

  const handleCopy = async laudo => {
    try {
      const data = await fetchStressByCod(laudo.CODLAUDO);
      onCopy(data);
      onHide();
    } catch (error) {
      toast.error('Erro ao copiar laudo de Stress.');
    }
  };

  return (
    <Modal show={show} onHide={onHide} size="xl" centered>
      <Modal.Header closeButton>
        <Modal.Title>Selecionar Laudo de Stress Anterior</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {loading ? (
          <div className="text-center py-4">
            <Spinner animation="border" />
          </div>
        ) : laudos.length === 0 ? (
          <p className="text-center text-muted">Nenhum laudo encontrado.</p>
        ) : (
          <Table
            size="sm"
            style={{ marginTop: 10, background: '#f8f9fa' }}
            striped
            hover
            bordered
            responsive
          >
            <thead>
              <tr>
                <th style={{ width: '110px', textAlign: 'center' }}>Data</th>
                <th style={{ width: '120px', textAlign: 'center' }}>Código</th>
                <th style={{ width: '180px', textAlign: 'center' }}>Ações</th>
              </tr>
            </thead>
            <tbody>
              {laudos.map(laudo => (
                <tr key={laudo.CODLAUDO}>
                  <td style={{ textAlign: 'center' }}>{laudo.dataFormatada}</td>
                  <td style={{ textAlign: 'center' }}>{laudo.CODLAUDO}</td>
                  <td style={{ textAlign: 'center' }}>
                    <OverlayTrigger
                      placement="top"
                      overlay={
                        <Tooltip id={`tooltip-laudo-${laudo.CODLAUDO}`}>
                          Copiar todos os dados do laudo
                        </Tooltip>
                      }
                    >
                      <Button
                        variant="outline-primary"
                        size="sm"
                        onClick={() => handleCopy(laudo)}
                      >
                        <FaRegCopy style={{ marginRight: 4 }} />
                        Copiar Laudo
                      </Button>
                    </OverlayTrigger>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          Fechar
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
